module.exports = __webpack_public_path__ + "img/ricelog_pinicon_011.0ecebdf0.png";